import {
  colourCommercialMessageBtiRed,
  colourInteractivePrimaryBgDefault,
  colourInteractiveSubtleBorderDefault,
  colourInteractiveSubtleBorderSelected,
  colourStaticLightGrey,
  colourStaticWhite,
} from '@ingka/variables';

import type { ISceneColors } from '.';

export const COLORS = {
  BACKGROUND_WHITE: colourStaticWhite,
  BACKGROUND_LIGHTGRAY: colourStaticLightGrey,
  ERROR_RED: colourCommercialMessageBtiRed,
  BORDER_BLACK: colourInteractiveSubtleBorderSelected,
  BORDER_GRAY: colourInteractiveSubtleBorderDefault,
  BACKGROUND_TEAL: '#9AB0A9',
  BACKGROUND_SCENE: '#f2f2f2',
  WHITE: colourStaticWhite,
  COMPONENT_PRIMARY_DEFAULT: colourInteractivePrimaryBgDefault,
  CARD_GREEN: '#AFCDC4',
};

export const SCENE_COLORS: ISceneColors = {
  grayEnhancedParent: {
    r: 200 / 255,
    g: 200 / 255,
    b: 200 / 255,
    a: 255 / 255,
  },
  grayEnhanced: { r: 230 / 255, g: 230 / 255, b: 230 / 255, a: 255 / 255 },
  grayBright: { r: 245 / 255, g: 245 / 255, b: 245 / 255, a: 255 / 255 },
  gray: { r: 220 / 255, g: 220 / 255, b: 220 / 255, a: 255 / 255 },
  blue: { r: 0 / 255, g: 88 / 255, b: 163 / 255, a: 255 / 255 },
  red: { r: 205 / 255, g: 46 / 255, b: 84 / 255, a: 255 / 255 },
};

export const OutlineColor: ISceneColors = {
  hover: { r: 255 / 255, g: 255 / 255, b: 255 / 255, a: 255 / 255 },
  select: { r: 21 / 255, g: 146 / 255, b: 230 / 255, a: 255 / 255 },
};
